// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as GemTransformExtended } from '../../../assets/icons/extended/entities/gem-transform.svg?react';
import { createIcons } from '../../Icon';
const GemTransformIcon = /* @__PURE__ */ createIcons('GemTransform', {
    extended: GemTransformExtended
});
GemTransformIcon.supportedTypes = ['extended'];
GemTransformIcon.category = 'entities';
export default GemTransformIcon;
